module.exports = __webpack_public_path__ + "static/media/scene_creator_onboarding_4.eba1045f.jpg";